/**
 * Android platform files
 */

export {default as commands} from './commands';
export {projectConfig, dependencyConfig} from './config';
export {getAndroidProject, getPackageName} from './config/getAndroidProject';
